var path = 'app/components/radniNalog/zub.html';
var html = "<g id=\"17\" ng-click=\"vm.onclick(vm.id)\" style=\"fill:white\"><path ng-repeat=\"p in paths\" d=\"{{p}}\" style=\"stroke:#000000;stroke-width:10.66666698;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1\"></path></g>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/radniNalog/zub.html
// module id = 635
// module chunks = 0